export const TESTIMONIALS_SECTION = {
  heading: "Don't just take our word for it",
  testimonials: [
    {
      quote:
        '"Our boring meals are once again adventurous! Food bill is reduced as I no longer buy veg and meat that I forget to use. On to our third week of orders now - delicious!"',
      author: 'Alison, St Albans',
    },
    {
      quote:
        '"I love it. I was getting so sick of my 15-dish repertoire! Now, I eat food I wouldn’t normally cook and we don’t waste any food. My partner and I are both super happy with Gousto – can’t wait for next week’s box!"',
      author: 'Claudia, Leeds',
    },
    {
      quote: '"A quick and easy way to cook from scratch."',
      author: 'Katy, London',
    },
  ],
}
